import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
/**
 * TabPanel 应该用在 Tabs 内部，如果单独使用，会直接渲染其 children
 */
export var TabPanel = React.forwardRef(function TabPanel(_a, ref) {
    var children = _a.children, id = _a.id, forceRender = _a.forceRender, className = _a.className, _b = _a.style, style = _b === void 0 ? {} : _b, props = __rest(_a, ["children", "id", "forceRender", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-tabs__tabpanel", className), style: __assign(__assign({}, style), { flexShrink: 0 }) }, props), children));
});
TabPanel.displayName = "TabPanel";
//# sourceMappingURL=TabPanel.js.map